import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight, FaYelp } from "react-icons/fa";
import Profile from "../assets/images/TestimonialProfile.png";

interface Testimonial {
  id: string;
  name: string;
  description: string;
  rating: string;
  image: string;
  platformIcon?: JSX.Element;
}

const dummyTestimonials: Testimonial[] = [
  {
    id: "1",
    name: "Krystal G",
    description:
      "Lisa Hale at Travel N' Relax goes above and beyond to make any trip amazing every step of the way. She listened to everything I wanted in a vacation and sent numerous hotel and excursion options to ensure the right fit! She is very knowledgeable, friendly and responsive! She even sent out travel tips beforehand to help with planning and put my mind at ease leaving the country...especially during COVID. I would recommend Travel N' Relax to anyone who wants a spectacular trip - I can't wait to work with you on another fun vacation!.",
    rating: "5",
    image: "",
  },
  {
    id: "2",
    name: "John B",
    description:
      "Working with Travel n Relax has been a great experience. Very responsive communication and helped with all aspects of the vacation. Thanks Rob!!!",
    rating: "5",
    image: "",
  },
  {
    id: "3",
    name: "Rich P",
    description:
      "To think that I thought I was getting the best deal by hopelessly searching through travel sites to plan my trips. Rob, takes traveling to an entirely different level. Sure you can do the touristy stuff....but with Rob planning your adventure, you will get to actually experience different cultures and cuisine in no way you could have ever planned it online. The best part, his meticulous planning ensures that you know how much you will spend before you go; rather than running into those, painfully expensive, unexpected costs - which makes that relaxing vacation...well...relaxing!",
    rating: "5",
    image: "",
  },
  {
    id: "4",
    name: "Alex D",
    description:
      "Rob is an experienced professional and industry leader. I would trust no one else more with my travel plans as I know he will be able to provide me with better pricing and experience than I could do on my own",
    rating: "5",
    image: "",
  },
  {
    id: "5",
    name: "Dave S",
    description:
      "Lisa helped us plan our EU honeymoon and I can't begin to describe how much it did for us. I've planned EU trips for myself before and it was a part-time job, between the logistics and finding fun things to do. We went to 4 cities between 3 countries and it couldn't have gone smoother. Lisa took a huge load off our shoulders by getting all of that done for us, putting us in great hotels, getting champagne into our rooms, finding rides from the hotel to the train stations/airports and giving us the best tours of the Louvre and Berlin we could've possibly had. When our trip back to the US got cancelled by British Airways, she was available to help with trying to reschedule some things. Life-changing experience and it's thanks to her. It was our first time using a travel agent and we're never going back to doing it by ourselves. Best honeymoon we could've asked for. Massive thanks to Lisa!",
    rating: "5",
    image: "",
  },
  {
    id: "6",
    name: "Isaiah B",
    description:
      "My Fiancé Jon and I are getting married this September and wanted to plan a Friendmoon/bachelor party with all of our close friends somewhere in paradise. I enlisted the help from Lisa H. from Travel n Relax to help plan this trip with our friends. Let me tell you, from the moment I reached out with ideas on where we were thinking of going, Lisa got right to work for us and sent us several options in Mexico based on what we wanted. We chose the beautiful beaches of Puerto Vallarta, Mexico for this trip. Once we nailed down the perfect specifics Lisa Curated an amazing itinerary for our entire group. She handled all of the reservations for the entire group of 14. Assisting each of our friends with their specific travel needs and made sure we did not need to plan a single thing and gave us the confidence that she was going to take care of everything for us. Boy did she handle everything perfectly cause our entire group had the time of our life's and made a truly unforgettable trip that we will all cherish for a lifetime!I can not thank Lisa with Travel n Relax enough for curating such an incredible trip for us. We highly recommend Travel N Relax for all of your travel needs, as they will take care of everything planning wise for you. We will be utilizing Travel n Relax for our upcoming Honeymoon in Europe and all of our future travel endeavors.Thank you Lisa from the bottom of our hearts for everything and helping us create a special moment! -Isaiah Bruno",
    rating: "5",
    image: "",
  },
  {
    id: "7",
    name: "William B",
    description:
      "We have worked with Lisa on two separate trips over the last two years and I would strongly recommend her for anyone looking for travel resources. She has always been extremely responsive and a pleasure to work with.",
    rating: "5",
    image: "",
  },
  {
    id: "8",
    name: "Carol Z",
    description:
      "We had a great trip planned through TravelNRelax, working with Lisa. We had 12 people in three generations, spanning 70 years, meeting for a family ski vacation over a long weekend in January. It was a complicated trip to get everyone from their homes to Aspen, to rent skis for some, but not for others, to sign some up for lessons and some not, to arrange for lift tix, to rent two condos to accommodate all of us, and the arrange for food to be delivered to our condos in advance of our arrival. All of this worked our smoothly. On the return home, there was a storm and six of us had our flights cancelled and rebooked, needing overnight lodging, a vehicle rental and driving to a different airport 4 hours away. Lisa was with us every step of the way, but also was calm, and helped us gather paperwork we'd need to be reimbursed by insurance for the snow-cancelled flight that we missed when the entire airport shut down. I recommend TravelNRelax for its conscientiousness and helpfulness.",
    rating: "5",
    image: "",
  },
  {
    id: "9",
    name: "Sherry L ",
    description:
      "Lisa was very helpful in booking an anniversary getaway for my husband and myself to Cancun. We wanted to fly our kids to Austin, where family could take care of them, while we flew to Cancun. She helped us coordinate our flights leaving Denver airport and arriving back to Denver around the same time. The trip was very smooth, her fee was reasonable, and we felt so grateful to have her help and expertise. The resort she helped us pick was fantastic, the food was great, and the transportation while in Mexico was professional and timely. I highly recommend Lisa to help with your vacation planning needs!",
    rating: "5",
    image: "",
    platformIcon: <FaYelp className="text-red-600 text-xl ml-2" />,
  },

  {
    id: "10",
    name: "Marilyn C",
    description:
      "Veronica saved my trip! I saw the reviews for this service and left a message late in the afternoon. I called again the next morning, Veronica answered and I went in for an appointment the next day. My passport had been lost (long story) and within two weeks she handed me a new one, on exactly the day she promised. She has a step-by-step process that worked well - just follow the instructions! I would highly recommend her to anyone. Thank you Veronica!",
    rating: "5",
    image: "",
    platformIcon: <FaYelp className="text-red-600 text-xl ml-2" />,
  },

  {
    id: "10",
    name: "Kyle B",
    description:
      "I needed a visa within two weeks and Veronica made that happen for me. This is my first Visa so I did not know what to do, but Veronica made that process very understandable and simple for me. She was very kind and patient with me and kept in touch with me throughout the entire process. Most importantly she said I would get my Visa by a specific date (which was close to my departure date) and she made it all happen by that date. She made a very stressful process easy and all my stresses melted away. I wouldn't recommend anyone else if you need to get a Visa quickly or need help understanding how the whole visa process works. Thanks Veronica",
    rating: "5",
    image: "",
    platformIcon: <FaYelp className="text-red-600 text-xl ml-2" />,
  },

  {
    id: "10",
    name: "Kaze G",
    description:
      "Really sweet person and very helpful service! Is highly recommend if you're nervous about going through the mail system. Totally worth the peace of mind!",
    rating: "5",
    image: "",
    platformIcon: <FaYelp className="text-red-600 text-xl ml-2" />,
  },
];

const TestimonialLanding: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);

  const testimonial = dummyTestimonials[currentIndex];

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % dummyTestimonials.length);
    setExpanded(false);
  };

  const prev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? dummyTestimonials.length - 1 : prev - 1
    );
    setExpanded(false);
  };

  return (
    <section className="w-full px-6 py-12 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-gray-800 uppercase tracking-wide">
           Testimonials
        </h2>

        <div className="flex items-center justify-between gap-4">
          {/* Left Arrow */}
          <button
            onClick={prev}
            className="bg-white p-3 rounded-full shadow hover:bg-blue-50 transition"
          >
            <FaChevronLeft className="text-gray-700" />
          </button>

          {/* Testimonial Card */}
          <div className="bg-gray-50 rounded-xl shadow-md p-6 sm:p-8 flex flex-col sm:flex-row gap-6 items-start flex-1">
            {/* <div className="flex-shrink-0">
          <img
            src={Profile}
            alt="Reviewer"
            className="w-16 h-16 rounded-full object-cover"
          />
        </div> */}

            <div className="flex-1">
              <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                {testimonial.name}
                {testimonial.platformIcon}
              </h3>

              <div className="flex items-center mb-3 mt-1">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className={`w-5 h-5 ${
                      i < parseInt(testimonial.rating)
                        ? "text-yellow-400"
                        : "text-gray-300"
                    }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.518 4.674a1 1 0 00.95.69h4.9c.967 0 1.371 1.24.588 1.81l-3.97 2.879a1 1 0 00-.364 1.118l1.518 4.674c.3.921-.755 1.688-1.538 1.118l-3.97-2.879a1 1 0 00-1.175 0l-3.97 2.879c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.364-1.118L2.993 9.1c-.783-.57-.379-1.81.588-1.81h4.9a1 1 0 00.95-.69l1.518-4.674z" />
                  </svg>
                ))}
              </div>

              <p
                className={`text-gray-700 text-base leading-relaxed ${
                  expanded ? "line-clamp-none" : "line-clamp-5"
                }`}
              >
                {testimonial.description}
              </p>

              {testimonial.description.length > 250 && (
                <button
                  className="text-blue-600 mt-2 text-sm hover:underline"
                  onClick={() => setExpanded(!expanded)}
                >
                  {expanded ? "Read Less" : "Read More"}
                </button>
              )}
            </div>
          </div>

          {/* Right Arrow */}
          <button
            onClick={next}
            className="bg-white p-3 rounded-full shadow hover:bg-blue-50 transition"
          >
            <FaChevronRight className="text-gray-700" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialLanding;
